/**
 * A titled card of the hypothesis page, the same shape as an investigation's sections; ``action``
 * sits beside the title (a button, a picker).
 */
import type { ReactNode } from 'react'
import { Card } from '@/components/ui/card'

export interface HypothesisSectionProps {
  title: string
  /** One line under the title. */
  hint?: string
  icon?: ReactNode
  action?: ReactNode
  children: ReactNode
}

export function HypothesisSection({ title, hint, icon, action, children }: HypothesisSectionProps) {
  return (
    <Card asChild className="p-4">
      <section>
        <header className="mb-4 flex flex-wrap items-start justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-center gap-2">
            {icon && (
              <span className="flex size-7 shrink-0 items-center justify-center rounded-lg border border-border bg-muted text-muted-foreground">
                {icon}
              </span>
            )}
            <div className="min-w-0">
              <h2 className="text-sm font-semibold text-foreground">{title}</h2>
              {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
            </div>
          </div>
          {action}
        </header>
        {children}
      </section>
    </Card>
  )
}
